module.exports = __webpack_public_path__ + "images/wave/feedbacks/romak.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/wave/feedbacks/romak.jpg
// module id = g8h2
// module chunks = 4